<div class="columns is-multiline">
  <div class="column is-3 is-flex" *ngFor="let item of deviceList$ | async; trackBy: trackByFn">
    <marketplace-device-card-template [poi]="item"></marketplace-device-card-template>
  </div>
</div>
